import { Component, Input } from '@angular/core';
import { ReceiptItemParkingResponse, ReceiptItemPrepaidParkingResponse, ReceiptItemSubscriptionResponse, ReceiptResponse } from '@bciti/types';

@Component({
    selector: 'app-user-receipt-summary',
    templateUrl: './user-receipt-summary.component.html',
    styleUrls: ['./user-receipt-summary.component.scss'],
})
export class UserReceiptSummaryComponent {
    @Input()
    public data: ReceiptResponse<ReceiptItemSubscriptionResponse | ReceiptItemParkingResponse | ReceiptItemPrepaidParkingResponse>;
}
